import React, { Children } from 'react';

import {
  arrayOf,
  bool,
  func,
  node,
  oneOf,
  oneOfType,
  shape,
  string
} from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';

import './Status.scss';

const STATUS_COLORS = {
  accent: 'Status--accent',
  default: 'Status--muted',
  muted: 'Status--muted',
  negative: 'Status--negative',
  positive: 'Status--positive',
  primary: 'Status--primary',
  warm: 'Status--warm'
};

export default class Status extends BaseComponent {
  handleClick = e => {
    const { onClick } = this.props;

    if (onClick) {
      onClick(e.target.value);
    }
  };

  render() {
    const { children, className, color, id, inverted, style } = this.props;

    const { handleClick } = this;

    const classNames = ClassNames('Status', className, STATUS_COLORS[color], {
      'Status--inverted': inverted
    });

    return (
      <button
        type="button"
        style={style}
        id={id}
        className={classNames}
        onClick={handleClick}
      >
        {Children.map(children, child => {
          return typeof child === 'string' ? child.toUpperCase() : child;
        })}
      </button>
    );
  }
}

Status.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  className: string,
  color: oneOf(Object.keys(STATUS_COLORS)),
  id: string,
  inverted: bool,
  onClick: func,
  style: shape({})
};

Status.defaultProps = {
  className: '',
  color: 'muted',
  id: undefined,
  inverted: false,
  style: {}
};
